import { skillsCategories } from '../config/skillsConfig';

/**
 * Get the label for a given skill key.
 * @param {string} skillKey - The key of the skill (e.g., '107').
 * @returns {string} - The label of the skill (e.g., 'FAA Part 107'), or the skillKey if not found.
 */
export const getSkillLabel = (skillKey) => {
    for (const category of skillsCategories) {
        const skill = category.skills.find((s) => s.key === skillKey);
        if (skill) {
            return skill.label;
        }
    }
    return skillKey; // Return the key if no label is found
};